import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
import { PuzzleWithSolution } from '../../components/Eiyuden/Puzzle';
import { Battle as Info } from '../../components/Battle/Battle';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Eiyuden Rising any%" mdxType="SEO" />
    <h2 {...{
      "id": "info"
    }}>{`Info`}</h2>
    <p>{`Health Potion pickups aren't listed. Pick up however many you need.`}</p>
    <h2 {...{
      "id": "0-defeat-the-bandits"
    }}>{`0: Defeat the Bandits!`}</h2>
    <p>{`Walk Forward 2A JA 2A`}<br parentName="p"></br>{`
`}{`5 Attacks`}</p>
    <h2 {...{
      "id": "1-first-day-on-the-job"
    }}>{`1: First Day on the Job`}</h2>
    <p>{`Talk to 4NPCs in Plaza.`}<br parentName="p"></br>{`
`}{`Walk to `}<strong parentName="p">{`Great Forest`}</strong>{`, rescue Yum-yum.`}</p>
    <h2 {...{
      "id": "2-repair-my-broken-house"
    }}>{`2: Repair my broken house!`}</h2>
    <p>{`Go to Residential District. After talking to guy, enter `}<strong parentName="p">{`Residential Interior District`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Great Forest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "great-forest"
    }}>{`Great Forest`}</h3>
    <p>{`Get `}<strong parentName="p">{`3 Lumber`}</strong>{` and exit.`}</p>
    <p>{`TP `}<strong parentName="p">{`Residential Interior District`}</strong>{`, go back to Residential District, talk to Ganesh.`}<br parentName="p"></br>{`
`}{`Examine your base.`}</p>
    <h2 {...{
      "id": "3-old-shivas-clock-tower"
    }}>{`3: Old Shiva's Clock Tower`}</h2>
    <p>{`TP `}<strong parentName="p">{`Plaza`}</strong>{`. Talk to `}<strong parentName="p">{`Shiva`}</strong>{`, go to `}<strong parentName="p">{`Great Forest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "great-forest-1"
    }}>{`Great Forest`}</h3>
    <p>{`Speed through, try to collect `}<strong parentName="p">{`8 Lumber`}</strong>{`.`}<br parentName="p"></br>{`
`}{`You will need to get 1 Titan Nectar, so kill flowers during your Great Forest trips until you get one.`}</p>
    <h4 {...{
      "id": "hollow-plant"
    }}>{`Hollow Plant`}</h4>
    <p>{`4-5 hits to break shield. Can avoid bad attack position by waiting till it starts attack before moving forward.`}<br parentName="p"></br>{`
`}{`Worm pattern: 2A JA 2A DF 2A`}<br parentName="p"></br>{`
`}{`Make sure you are far enough that the JFA doesnt run into Worm's hitbox`}</p>
    <p>{`Leave through sign, TP `}<strong parentName="p">{`Plaza`}</strong>{`, talk to `}<strong parentName="p">{`Shiva`}</strong>{`.`}</p>
    <h2 {...{
      "id": "4-the-cost-of-good-manners"
    }}>{`4: The Cost of Good Manners`}</h2>
    <p>{`Talk to `}<strong parentName="p">{`Isha`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Outlander Lane`}</strong>{`, talk to `}<strong parentName="p">{`Sarita`}</strong>{` and `}<strong parentName="p">{`Rajiv`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Great Forest`}</strong>{`. Warp to `}<strong parentName="p">{`Giant Tree Glade`}</strong>{`.`}</p>
    <h3 {...{
      "id": "great-forest---giant-tree-glade"
    }}>{`Great Forest - Giant Tree Glade`}</h3>
    <p>{`Go west, pick up `}<strong parentName="p">{`Lightweight Lumber`}</strong>{` & `}<strong parentName="p">{`Giant Stone`}</strong>{`, picking up `}<strong parentName="p">{`2 Lumber`}</strong>{` on the way.`}<br parentName="p"></br>{`
`}{`Go back to sign and exit.`}</p>
    <ol>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Outlander Lane`}</strong>{`. Talk to `}<strong parentName="li">{`Sarita`}</strong>{`.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Plaza`}</strong>{`, talk to `}<strong parentName="li">{`Isha`}</strong>{`.`}</li>
    </ol>
    <h2 {...{
      "id": "5-the-miner-the-merc-and-the-smithy"
    }}>{`5: The Miner, the Merc, and the Smithy`}</h2>
    <ol>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Town Outskirts`}</strong>{`, go to `}<strong parentName="li">{`Quarry`}</strong>{`. Go to bottom-right to trigger cutscene.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Outlander Lane`}</strong>{`, talk to `}<strong parentName="li">{`Tatara`}</strong>{`.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Quarry`}</strong>{`, get top `}<strong parentName="li">{`3 Ore`}</strong>{`. Pathing is 4DJ, get bottom ore, jump over right slime, then dash back across.`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`DF x4, 4th goes through slime. Dash off platform, walk forward a few steps, attack and jump for 2nd Ore.`}</li>
      <li parentName="ul">{`Jump over right slime, get Ore and jump back over. Dash / Walk to platform in gap, continue to exit.`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Don't bother killing stuff right now, damage is reduced.`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`Outlander Lane`}</strong>{`, talk to `}<strong parentName="p">{`Tatara`}</strong>{` twice.`}</p>
    <h2 {...{
      "id": "6-trouble-in-the-quarry"
    }}>{`6: Trouble in the Quarry`}</h2>
    <p>{`TP `}<strong parentName="p">{`Great Forest`}</strong>{`, warp `}<strong parentName="p">{`Forest Cave`}</strong>{`. `}</p>
    <h3 {...{
      "id": "great-forest---forest-cave"
    }}>{`Great Forest - Forest Cave`}</h3>
    <p>{`Farm 2 left & 1 right `}<strong parentName="p">{`Stone`}</strong>{`, kill Gargoyles and Slimes.`}<br parentName="p"></br>{`
`}{`TP out and back in and do it again, want 6 total.`}</p>
    <Info mdxType="Info">
      <p><strong parentName="p">{`At This Point Need`}</strong></p>
      <ul>
        <li parentName="ul">{`Gargoyle Wings: 3/12`}</li>
        <li parentName="ul">{`Slimejelly: 2/6 (Have one more chance during Paint trip)`}</li>
      </ul>
    </Info>
    <ol>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Quarry`}</strong>{`. Enter for cutscene.`}</li>
      <li parentName="ol">{`Talk to `}<strong parentName="li">{`Karina`}</strong>{` to complete quest.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Outlander Lane`}</strong>{`, talk to `}<strong parentName="li">{`Bertrand`}</strong>{`.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Residential Interior District`}</strong>{`. Talk to `}<strong parentName="li">{`Isha`}</strong>{`.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Outlander Lane`}</strong>{`, talk to `}<strong parentName="li">{`Bertrand`}</strong>{`. Upgrade `}<strong parentName="li">{`CJ's Weapon`}</strong>{`.`}</li>
    </ol>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon"
      }}>{`Weapon`}</h5>
      <p>{`Upgrade CJ. `}<em parentName="p">{`Check `}<strong parentName="em">{`Gargoyle Wing`}</strong>{` count, need `}<strong parentName="em">{`12`}</strong>{` total before upgrade.`}</em></p>
    </Menu>
    <ol>
      <li parentName="ol">{`Talk to `}<strong parentName="li">{`Frida`}</strong>{`. `}</li>
    </ol>
    <p>{`TP `}<strong parentName="p">{`Great Forest`}</strong>{`. Warp `}<strong parentName="p">{`Forest Cave`}</strong>{`.`}</p>
    <h3 {...{
      "id": "great-forest---forest-cave-1"
    }}>{`Great Forest - Forest Cave`}</h3>
    <ol>
      <li parentName="ol">{`Get 3 Stone, kill Gargoyles. Then go down bottom path. Get all Crystals.`}</li>
      <li parentName="ol">{`Pick `}<strong parentName="li">{`Power Balm`}</strong>{`. `}<strong parentName="li">{`SKIP`}</strong>{` chest after sign (useless Crit Balm 1).`}</li>
      <li parentName="ol">{`Kill Wolf, get `}<strong parentName="li">{`Paint`}</strong>{`. Optionally break jars for potential drops. Warp out with sign.`}</li>
    </ol>
    <p>{`TP `}<strong parentName="p">{`Outlander Lane`}</strong>{`, talk to `}<strong parentName="p">{`Frida`}</strong>{`. Upgrade `}<strong parentName="p">{`CJ's Armor`}</strong>{`.`}</p>
    <ol>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Plaza`}</strong>{`. Go to right, talk to `}<strong parentName="li">{`Robert`}</strong>{`.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Residential Interior`}</strong>{`, trigger. TP `}<strong parentName="li">{`Outlander Lane`}</strong>{`, trigger, go to `}<strong parentName="li">{`Second Street`}</strong>{`. Talk to `}<strong parentName="li">{`Robert`}</strong>{`.`}</li>
      <li parentName="ol">{`Craft `}<strong parentName="li">{`1 Healing Potion`}</strong>{`. `}<em parentName="li">{`Check `}<strong parentName="em">{`Slimejelly`}</strong>{`, should have `}<strong parentName="em">{`7`}</strong></em></li>
    </ol>
    <h2 {...{
      "id": "7-catch-that-girl"
    }}>{`7: Catch That Girl!`}</h2>
    <ol>
      <li parentName="ol">{`Talk to `}<strong parentName="li">{`Rene`}</strong>{` and `}<strong parentName="li">{`Hogan`}</strong>{`.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Residential Distict`}</strong>{`, `}<em parentName="li">{`Auto-Sleep`}</em>{`.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Quarry`}</strong>{`.`}</li>
    </ol>
    <h3 {...{
      "id": "quarry"
    }}>{`Quarry`}</h3>
    <Info mdxType="Info">
      <h6 {...{
        "id": "track-drops"
      }}>{`Track Drops`}</h6>
      <ul>
        <li parentName="ul">{`Yellow Slimejelly: 4`}</li>
        <li parentName="ul">{`Stone Wings: 9`}</li>
      </ul>
    </Info>
    <blockquote>
      <p parentName="blockquote">{`Assuming you pick up all routed Ore / Lumber, you will have 2 extra Lumber to trade for a Stone in the final trading menu. Meaning, you can miss up to 2 routed Ores.`}</p>
    </blockquote>
    <p>{`Pick up 4 `}<strong parentName="p">{`Ore`}</strong>{` along path (top 2 Ore + 2 bottom right Ore, killing Gargoyle's on the way).`}<br parentName="p"></br>{`
`}{`Pick all `}<strong parentName="p">{`Amber Crystal`}</strong>{` on the way. `}<em parentName="p">{`If you ever skip the 2 Amber Crystals here for the fight skip, you'll need to get extras later.`}</em><br parentName="p"></br>{`
`}{`Go up right, pull lever, go back down and to the right. Trigger cutscene.`}</p>
    <p>{`TP `}<strong parentName="p">{`Outlander Lane`}</strong>{`, talk to `}<strong parentName="p">{`Gacteau`}</strong>{`.`}</p>
    <h2 {...{
      "id": "8-defeat-the-lode-golem"
    }}>{`8: Defeat the Lode Golem!`}</h2>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "smithy"
      }}>{`Smithy`}</h5>
      <ul>
        <li parentName="ul">{`CJ: 3 (9 Ore)`}</li>
        <li parentName="ul">{`Garoo: 3`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Quarry`}</strong>{`.`}</p>
    <h4 {...{
      "id": "quarry-1"
    }}>{`Quarry`}</h4>
    <p>{`Pick up `}<strong parentName="p">{`4 Ore`}</strong>{` on first screen.`}<br parentName="p"></br>{`
`}{`Pick up all `}<strong parentName="p">{`Ore`}</strong>{` & `}<strong parentName="p">{`Amber Crystal`}</strong>{` along the way.`}<br parentName="p"></br>{`
`}{`When path goes down pick `}<strong parentName="p">{`1 Ore`}</strong>{` there. Continue to Golem.`}</p>
    <h4 {...{
      "id": "lode-golem"
    }}>{`Lode Golem.`}</h4>
    <p>{`Activate `}<strong parentName="p">{`Power Balm`}</strong>{`.`}<br parentName="p"></br>{`
`}{`When Golem starts windup for boulder toss, switch to Garoo and hit it back into him.`}<br parentName="p"></br>{`
`}{`Garoo JA > Link x2. This should knock Golem down.`}</p>
    <p>{`When Golem falls down: 4 CJ attacks > 2 Garoo > 4 CJ > 2 Garoo. If Garoo links just do 1 more attack with Garoo.`}</p>
    <h2 {...{
      "id": "9-into-the-ruins"
    }}>{`9: Into the Ruins`}</h2>
    <p>{`If < 2 money drops, pick `}<strong parentName="p">{`Defense Ring LV1`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Continue to Rune Barrows. Double Link to kill Bandits.`}</p>
    <h2 {...{
      "id": "10-the-mystery-of-the-menhir"
    }}>{`10: The Mystery of the Menhir`}</h2>
    <h4 {...{
      "id": "puzzle"
    }}>{`Puzzle`}</h4>
    <PuzzleWithSolution puzzle={[[0, 0], [2, 2], [2, 0], [0, 0], [0, 0], [0, 0], [1, 1], [0, 0], [0, 0], [0, 0], [0, 0], [2, 2], [1, 0], [2, 3], [0, 0], [0, 0], [0, 0], [0, 0], [1, 0], [0, 0], [0, 0], [0, 0], [2, 2], [2, 0], [0, 0]]} moves={[[11, -1], [18, 1]]} mdxType="PuzzleWithSolution" />
    <h2 {...{
      "id": "11-on-the-other-side"
    }}>{`11: On the Other Side...`}</h2>
    <p>{`Run to `}<strong parentName="p">{`Farm`}</strong>{`. TP `}<strong parentName="p">{`Quarry`}</strong>{`. `}</p>
    <h4 {...{
      "id": "quarry-2"
    }}>{`Quarry`}</h4>
    <p>{`Warp `}<strong parentName="p">{`Golem's Keep`}</strong>{`. Kill Golem (same as before), and leave again.`}</p>
    <p>{`TP `}<strong parentName="p">{`Great Forest - Forest Cave`}</strong></p>
    <h3 {...{
      "id": "great-forest---forest-cave-2"
    }}>{`Great Forest - Forest Cave`}</h3>
    <Info mdxType="Info">
      <h6 {...{
        "id": "after-this-trip-need"
      }}>{`After this trip need`}</h6>
      <ul>
        <li parentName="ul">{`Slimejelly: 2`}</li>
        <li parentName="ul">{`Gargoyle Wings: 9`}</li>
      </ul>
    </Info>
    <ol>
      <li parentName="ol">{`Go down, picking `}<strong parentName="li">{`Crystal`}</strong>{` and killing Gargoyles along the way. Then go back up.`}</li>
      <li parentName="ol">{`Get `}<strong parentName="li">{`2 Stone on Left`}</strong>{`, and then go right, getting `}<strong parentName="li">{`1 Stone`}</strong>{` on the way.`}</li>
      <li parentName="ol">{`Next screen get `}<strong parentName="li">{`Hogan's Chest`}</strong>{` and `}<strong parentName="li">{`4 Lumber`}</strong>{`.`}</li>
      <li parentName="ol">{`Go right, fight the `}<strong parentName="li">{`Giant Tree`}</strong>{`.`}</li>
    </ol>
    <h4 {...{
      "id": "giant-tree"
    }}>{`Giant Tree`}</h4>
    <p>{`1 cycle is easy, break Shield with CJ, links for Worm.`}</p>
    <p>{`Break Boulder, pick `}<strong parentName="p">{`Strength Ring LV1`}</strong>{`. Pick `}<strong parentName="p">{`Agricultural Seed`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Then back to sign, warp out.`}</p>
    <p>{`TP `}<strong parentName="p">{`Farm`}</strong>{`. Talk to `}<strong parentName="p">{`Ayus`}</strong>{`. Go to `}<strong parentName="p">{`Pasturage`}</strong>{`, talk to `}<strong parentName="p">{`Urmila`}</strong>{` twice.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Lumber`}</strong>{` for Urmilla should be `}<strong parentName="p">{`11/6`}</strong></p>
    <h2 {...{
      "id": "12-bandit-busting"
    }}>{`12: Bandit Busting`}</h2>
    <ol>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Residential Interior District`}</strong>{`, get `}<strong parentName="li">{`$100 Chest`}</strong>{`.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Plaza`}</strong>{`. Talk to `}<strong parentName="li">{`Isha`}</strong>{`.`}</li>
    </ol>
    <h3 {...{
      "id": "quarry-3"
    }}>{`Quarry`}</h3>
    <p>{`Go to Earth Crystal for Cutscene & Exit. Pick up `}<strong parentName="p">{`5 Ore`}</strong>{` along the way.`}</p>
    <Info mdxType="Info">
      <h6 {...{
        "id": "after-next-quarry-trip-need"
      }}>{`After Next Quarry Trip Need`}</h6>
      <ul>
        <li parentName="ul">{`Yellow Slimejelly: 4`}</li>
        <li parentName="ul">{`Stone Wings: 9`}</li>
      </ul>
    </Info>
    <ol>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Second Street`}</strong>{`, Talk to `}<strong parentName="li">{`Rene`}</strong>{`. `}<strong parentName="li">{`Pawn Shop`}</strong>{`.`}</li>
    </ol>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pawn-shop"
      }}>{`Pawn Shop`}</h5>
      <ul>
        <li parentName="ul"><em parentName="li">{`Ebony Pelt`}</em></li>
        <li parentName="ul">{`2 Giant Branch`}</li>
        <li parentName="ul">{`All gold items`}</li>
        <li parentName="ul">{`Defense Ring if picked`}</li>
      </ul>
    </Menu>
    <ol>
      <li parentName="ol">{`Talk to `}<strong parentName="li">{`Hogan`}</strong>{` TWICE.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Outlander Lane`}</strong>{`. Talk to `}<strong parentName="li">{`Bertrand`}</strong>{`.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Town Outskirts`}</strong>{`, talk to `}<strong parentName="li">{`Ranbir`}</strong>{`.`}</li>
      <li parentName="ol">{`Enter `}<strong parentName="li">{`Plaza`}</strong>{`, talk to `}<strong parentName="li">{`Jashan`}</strong>{`.`}</li>
      <li parentName="ol">{`Enter `}<strong parentName="li">{`Outlander Lane`}</strong>{`. Talk to `}<strong parentName="li">{`Sarita`}</strong>{`, `}<strong parentName="li">{`Bertrand`}</strong>{`, `}<strong parentName="li">{`Frida`}</strong>{`.`}</li>
    </ol>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "inn"
      }}>{`Inn`}</h5>
      <p>{`Empowering Waters Lv.1`}</p>
    </Menu>
    <ol>
      <li parentName="ol">{`Enter `}<strong parentName="li">{`Rune Quarter`}</strong>{`.`}</li>
      <li parentName="ol">{`Talk to `}<strong parentName="li">{`Jashan`}</strong>{` twice. Talk to `}<strong parentName="li">{`Ilda`}</strong>{`.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Second Street`}</strong>{`. Talk to `}<strong parentName="li">{`Hogan`}</strong>{`. `}<strong parentName="li">{`Trading Post`}</strong>{`.`}</li>
    </ol>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "trading-post"
      }}>{`Trading Post`}</h5>
      <ul>
        <li parentName="ul">{`1 Heavy Stone (6 Stone)`}</li>
        <li parentName="ul">{`4 Huge Ore (17 Ore)`}</li>
        <li parentName="ul">{`Stamp Reward: 5 Ore`}</li>
      </ul>
    </Menu>
    <ol>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Plaza`}</strong>{`. Talk to `}<strong parentName="li">{`Isha`}</strong>{`.`}</li>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Rune Quarter`}</strong>{`, talk to `}<strong parentName="li">{`Ilda`}</strong>{`. Buy `}<strong parentName="li">{`Earth Rune`}</strong>{`. *Should have `}<strong parentName="li">{`11 Amber Crystal*`}</strong></li>
      <li parentName="ol">{`Talk to `}<strong parentName="li">{`Jeorg`}</strong>{` twice.`}</li>
    </ol>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`CJ: Strength Ring LV1, Earth Rune LV1`}</li>
      </ul>
    </Menu>
    <ol>
      <li parentName="ol">{`TP `}<strong parentName="li">{`Quarry`}</strong></li>
    </ol>
    <h3 {...{
      "id": "quarry-4"
    }}>{`Quarry`}</h3>
    <p>{`Go to Earth Crystal, picking `}<strong parentName="p">{`5 Ore`}</strong>{` along the way.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`2 Bronze Ore`}</strong>{` on the way, continue till end for money, `}<strong parentName="p">{`Bronze Ore`}</strong>{`, and `}<strong parentName="p">{`Whetstone`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Backtrack & exit.`}</p>
    <p>{`TP `}<strong parentName="p">{`Residential District`}</strong>{`, walk to `}<strong parentName="p">{`Plaza`}</strong>{`. Talk to `}<strong parentName="p">{`Lugo`}</strong>{`.`}</p>
    <h2 {...{
      "id": "13-no-way-through"
    }}>{`13: No Way Through`}</h2>
    <p>{`TP & use `}<strong parentName="p">{`Farmside Menhir`}</strong>{`.`}</p>
    <h3 {...{
      "id": "runebarrows"
    }}>{`Runebarrows`}</h3>
    <p><strong parentName="p">{`Tag the Sign`}</strong>{`. It has a wonky activation.`}<br parentName="p"></br>{`
`}{`Break Earth Crystal, go forward.`}</p>
    <h4 {...{
      "id": "puzzle-2"
    }}>{`Puzzle 2`}</h4>
    <PuzzleWithSolution puzzle={[[0, 0], [0, 0], [2, 1], [2, 1], [0, 0], [0, 0], [2, 1], [2, 3], [1, 1], [0, 0], [0, 0], [1, 1], [1, 1], [1, 0], [0, 0], [0, 0], [1, 0], [2, 1], [2, 0], [0, 0], [0, 0], [2, 3], [2, 3], [0, 0], [0, 0]]} moves={[[3, 2], [13, 1], [6, 1], [16, 1], [21, 2]]} mdxType="PuzzleWithSolution" />
    <h3 {...{
      "id": "snowpeak"
    }}>{`Snowpeak`}</h3>
    <Info mdxType="Info">
      <h6 {...{
        "id": "drops-needed-before-rune-golem"
      }}>{`Drops Needed before Rune Golem`}</h6>
      <ul>
        <li parentName="ul">{`4 Blue Slimejelly`}</li>
        <li parentName="ul">{`4 Icy Wing`}</li>
      </ul>
    </Info>
    <p>{`Optionally pick `}<strong parentName="p">{`Earth Balm LV1`}</strong>{`, use it before the forced fight.`}<br parentName="p"></br>{`
`}{`Just speed through with jump + air dash.`}<br parentName="p"></br>{`
`}{`There is 1 forced battle, try to pick up & track drops.`}</p>
    <h3 {...{
      "id": "14-the-search-for-a-magical-girl"
    }}>{`14: The Search for a Magical Girl`}</h3>
    <p>{`Back to Town, warp `}<strong parentName="p">{`Outlander Lane`}</strong>{`. Talk to `}<strong parentName="p">{`Gacteau`}</strong>{`.`}</p>
    <h3 {...{
      "id": "15-breaking-the-ice"
    }}>{`15: Breaking the Ice`}</h3>
    <p>{`Talk to `}<strong parentName="p">{`Tatara`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "smithy-1"
      }}>{`Smithy`}</h5>
      <ul>
        <li parentName="ul">{`CJ WPN: 8`}</li>
        <li parentName="ul">{`Isha WPN: 8`}</li>
      </ul>
      <h5 {...{
        "id": "weapon-1"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`CJ: +1`}</li>
        <li parentName="ul">{`Isha: +1`}</li>
      </ul>
    </Menu>
    <p>{`Talk to `}<strong parentName="p">{`Frida`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "armor"
      }}>{`Armor`}</h5>
      <ul>
        <li parentName="ul">{`CJ: +1`}</li>
      </ul>
    </Menu>
    <p>{`Warp `}<strong parentName="p">{`Farmside Menhir`}</strong>{`, Warp `}<strong parentName="p">{`Snowpeaks - Ascent`}</strong>{`.`}</p>
    <h3 {...{
      "id": "snowpeaks---ascent"
    }}>{`Snowpeaks - Ascent`}</h3>
    <p>{`Start killing Flans now with CJ + Isha, farming for Blue Slimejelly.`}</p>
    <h3 {...{
      "id": "16-after-the-mayor"
    }}>{`16: After the Mayor`}</h3>
    <p>{`At fork take top path. `}<strong parentName="p">{`GET THE BRONZE ORE`}</strong>{`. `}</p>
    <h4 {...{
      "id": "puzzle-3"
    }}>{`Puzzle 3`}</h4>
    <PuzzleWithSolution puzzle={[[2, 2], [0, 0], [3, 1], [1, 0], [3, 1], [0, 0], [2, 0], [3, 0], [1, 1], [3, 0], [3, 0], [0, 0], [2, 3], [1, 1], [2, 3], [2, 2], [1, 1], [3, 1], [2, 3], [3, 0], [2, 2], [0, 0], [3, 1], [2, 1], [3, 3]]} moves={[[12, -1], [13, 1], [14, 1], [9, -1], [8, 1]]} mdxType="PuzzleWithSolution" />
    <h3 {...{
      "id": "runebarrows-1"
    }}>{`Runebarrows`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Need 4 Viridian Crystal total, 4 + 1 + 1 along the way.`}</p>
    </blockquote>
    <p>{`Try to skip the signs here, won't ever need them and they reduce menuing.`}</p>
    <p>{`1st screen kill 2 drakes at start, want a `}<strong parentName="p">{`Shock Wing`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Kill some later if no drop.`}</p>
    <p><strong parentName="p">{`Forced fight`}</strong>{`: Break shield with Isha 3A > Link Garoo > Link Isha > Garoo A. Then DPS.`}<br parentName="p"></br>{`
`}{`At fork take `}<strong parentName="p">{`BOTTOM`}</strong>{` path. Pick the `}<strong parentName="p">{`2 Bronze Ore`}</strong>{` before next screen.`}<br parentName="p"></br>{`
`}{`Pick the `}<strong parentName="p">{`Bronze Ore`}</strong>{` on the way. For the big jump, Isha attack > CJ > AD.`}</p>
    <p>{`Next screen, `}<strong parentName="p">{`go to top right`}</strong>{`. Pick `}<strong parentName="p">{`Bronze Ore`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Then go to bottom-right to next screen.`}</p>
    <h4 {...{
      "id": "rune-golem"
    }}>{`Rune Golem`}</h4>
    <p>{`Just DPS with CJ and Isha. Outside of his lightning attack his attacks are fairly easy to dodge.`}</p>
    <h2 {...{
      "id": "17-the-search-begins"
    }}>{`17: The Search Begins`}</h2>
    <h4 {...{
      "id": "puzzle-4"
    }}>{`Puzzle 4`}</h4>
    <PuzzleWithSolution puzzle={[[2, 2], [2, 0], [2, 0], [1, 0], [2, 3], [3, 3], [1, 0], [3, 1], [2, 2], [1, 0], [1, 0], [2, 1], [2, 0], [1, 0], [3, 2], [3, 2], [2, 2], [2, 1], [2, 2], [2, 1], [2, 2], [2, 0], [3, 3], [1, 1], [3, 0]]} moves={[[17, 1], [18, 2], [13, 1], [8, 1], [6, 1], [1, 2]]} mdxType="PuzzleWithSolution" />
    <h2 {...{
      "id": "snowpeak---crest"
    }}>{`Snowpeak - Crest`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Need 6 Azure Crystals`}</p>
    </blockquote>
    <p><strong parentName="p">{`Tag Sign here.`}</strong></p>
    <p>{`Get `}<strong parentName="p">{`3 Azure Crystals`}</strong>{` on bottom of first screen.`}</p>
    <h4 {...{
      "id": "wolf"
    }}>{`Wolf`}</h4>
    <p>{`Just try to not get combo'd. DPS as usual.`}</p>
    <h3 {...{
      "id": "18-mysterious-machinery"
    }}>{`18: Mysterious Machinery`}</h3>
    <p>{`Go to right, pick `}<strong parentName="p">{`Strength Ring LV2`}</strong>{`, 2 Silver, Lapis Lazuli`}</p>
    <p>{`Warp `}<strong parentName="p">{`Crest`}</strong>{`. Take `}<strong parentName="p">{`Menhir`}</strong>{` back to `}<strong parentName="p">{`Runebarrows`}</strong>{`.`}</p>
    <h3 {...{
      "id": "runebarrows-2"
    }}>{`Runebarrows`}</h3>
    <p>{`Go left for cutscene.`}</p>
    <h3 {...{
      "id": "19-the-humoungous-lens"
    }}>{`19: The Humoungous Lens`}</h3>
    <p>{`At fork go to top-right.`}</p>
    <h4 {...{
      "id": "puzzle-5"
    }}>{`Puzzle 5`}</h4>
    <PuzzleWithSolution puzzle={[[0, 0], [2, 1], [2, 0], [2, 3], [2, 3], [2, 3], [2, 1], [0, 0], [1, 1], [1, 0], [3, 0], [1, 0], [1, 0], [1, 1], [1, 1], [2, 2], [1, 0], [1, 1], [2, 1], [1, 0], [0, 0], [2, 1], [2, 1], [1, 1], [2, 0]]} moves={[[22, 1], [23, 1], [19, 1], [9, -1], [3, -1], [18, -1], [17, -1], [15, -1], [10, 1], [5, -1], [6, -1], [1, 1]]} mdxType="PuzzleWithSolution" />
    <h3 {...{
      "id": "snowpeak---summit"
    }}>{`Snowpeak - Summit`}</h3>
    <p>{`Pick `}<strong parentName="p">{`3 Azure Crystal`}</strong>{`.`}</p>
    <p>{`1st group: get close, jump, AD through vertical gap, double jump.`}<br parentName="p"></br>{`
`}{`2nd group: Double jump forward when close to flan, AD through wizard.`}<br parentName="p"></br>{`
`}{`3rd group: Double jump, Up Attack, Air Dash`}<br parentName="p"></br>{`
`}{`4th group: Switch to Isha, jump forward and hit drake. Link CJ, spam AD then double jump.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`CJ: Remove Strength Ring, Earth Rune`}</li>
        <li parentName="ul">{`Isha: Strength Ring LV1, Strength Ring LVL2, Earth Rune`}</li>
      </ul>
    </Menu>
    <p>{`Next Screen: `}<strong parentName="p">{`Make sure your Stowbag isn't full.`}</strong>{` Pick `}<strong parentName="p">{`Earth Balm LV2`}</strong>{`.`}</p>
    <h4 {...{
      "id": "wolves"
    }}>{`Wolves`}</h4>
    <p>{`Use `}<strong parentName="p">{`Earth Balm LV2`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Prioritize not taking damage, and killing the small wolves.`}<br parentName="p"></br>{`
`}{`Hit when possible.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Theory: Staying on right side delays 2nd Wolf spawn?`}</p>
    </blockquote>
    <h4 {...{
      "id": "blizzard-brothers"
    }}>{`Blizzard Brothers`}</h4>
    <p>{`Isha Jump 3A > CJ > Isha > CJ 2A UA DA > Isha 3A > CJ 2A UA DA > Link Isha > Link CJ > Isha 3A`}<br parentName="p"></br>{`
`}{`Repeat this pattern rest of fight, you should never even touch the ground.`}</p>
    <h2 {...{
      "id": "20-a-life-worth-dying-for"
    }}>{`20: A Life Worth Dying For`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Hogan 3rd quest unlocks here. (Confirmed)`}</p>
    </blockquote>
    <p>{`Go back to sign, exit Runebarrows.`}</p>
    <h3 {...{
      "id": "new-nevea"
    }}>{`New Nevea`}</h3>
    <p>{`Warp `}<strong parentName="p">{`Outlander Lane`}</strong>{`. Go to Tavern.`}<br parentName="p"></br>{`
`}{`Etner `}<strong parentName="p">{`Plaza`}</strong>{`, talk to 3 right NPCs. TP `}<strong parentName="p">{`Great Forest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "great-forest---hellhound-lake"
    }}>{`Great Forest - Hellhound Lake`}</h3>
    <p>{`Warp `}<strong parentName="p">{`Hellhound Lake`}</strong>{`. Go to next screen for cutscene, then go back.`}</p>
    <p>{`Warp `}<strong parentName="p">{`Rune Quarter`}</strong>{`, then warp `}<strong parentName="p">{`Second Street`}</strong>{`.`}</p>
    <p>{`Talk to `}<strong parentName="p">{`Hogan`}</strong>{`. `}<strong parentName="p">{`Pawn Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pawn-shop-1"
      }}>{`Pawn Shop`}</h5>
      <ul>
        <li parentName="ul">{`Lapis Lazuli`}</li>
        <li parentName="ul">{`Silver`}</li>
        <li parentName="ul">{`White Pelts`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Outlander Lane`}</strong>{`. Talk to `}<strong parentName="p">{`Tatara`}</strong>{` twice.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "smithy-2"
      }}>{`Smithy`}</h5>
      <ul>
        <li parentName="ul">{`CJ WPN: Max`}</li>
        <li parentName="ul">{`Isha WPN: Max`}</li>
      </ul>
    </Menu>
    <p>{`Talk to `}<strong parentName="p">{`Gacteau`}</strong>{`.`}</p>
    <h2 {...{
      "id": "21-the-search-for-the-humongous-lens"
    }}>{`21: The Search for the Humongous Lens`}</h2>
    <p>{`Warp `}<strong parentName="p">{`Quarry`}</strong>{`.`}</p>
    <h3 {...{
      "id": "quarry---cavern"
    }}>{`Quarry - Cavern`}</h3>
    <p>{`Warp `}<strong parentName="p">{`Cavern`}</strong>{`. Go left. Climb to top-left, collecting `}<strong parentName="p">{`2 Ore`}</strong>{` along the way.`}<br parentName="p"></br>{`
`}{`Go to next screen. Pick `}<strong parentName="p">{`Large Scale`}</strong>{`. Pull lever. Backtrack on down path and exit with sign.`}</p>
    <p>{`TP `}<strong parentName="p">{`Farmside Menhir`}</strong>{`. TP `}<strong parentName="p">{`Snowpeak - Blizzard's Point`}</strong>{`.`}</p>
    <h3 {...{
      "id": "snowpeak---blizzards-point"
    }}>{`Snowpeak - Blizzard's Point`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-2"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Isha: Lightning Rune`}</li>
      </ul>
    </Menu>
    <p>{`Continue forward.`}</p>
    <h4 {...{
      "id": "puzzle-6"
    }}>{`Puzzle 6`}</h4>
    <PuzzleWithSolution puzzle={[[2, 2], [1, 0], [2, 0], [2, 3], [0, 0], [1, 0], [1, 1], [0, 0], [2, 0], [2, 3], [3, 3], [1, 1], [1, 0], [1, 1], [1, 0], [2, 0], [1, 1], [1, 1], [1, 0], [2, 2], [2, 3], [3, 3], [2, 3], [2, 0], [2, 0]]} moves={[[2, 1], [8, 1], [14, 1], [19, 2], [17, 1], [16, 1], [15, 2], [20, 2], [21, 1]]} mdxType="PuzzleWithSolution" />
    <h3 {...{
      "id": "the-lava-ruins"
    }}>{`The Lava Ruins`}</h3>
    <p>{`Just go forward. Shouldn't need any money / pickups at this point.`}</p>
    <h2 {...{
      "id": "22-a-lens-to-light-the-way"
    }}>{`22: A Lens to Light the Way`}</h2>
    <p>{`At fork go up-right.`}</p>
    <h4 {...{
      "id": "fire-lizard"
    }}>{`Fire Lizard`}</h4>
    <p>{`Isha 3A > Garoo > Isha > Garoo Air Atk > CJ > ATKs into dash behind to dodge`}<br parentName="p"></br>{`
`}{`Isha > Garoo and alternate them. Standard after shield break.`}</p>
    <h3 {...{
      "id": "23-the-guardian-peacekeeper"
    }}>{`23: The Guardian Peacekeeper`}</h3>
    <p>{`After hallway screen, go left. Then climb up right.`}<br parentName="p"></br>{`
`}{`For last big jump, jump > AD at apex > DJ > Up ATK near end.`}</p>
    <p>{`Next screen dash through till forced battle.`}</p>
    <h4 {...{
      "id": "forced-battle"
    }}>{`Forced Battle`}</h4>
    <p>{`Play patiently, use Isha.`}</p>
    <h4 {...{
      "id": "mantor-wyrm"
    }}>{`Mantor Wyrm`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Does hitting head do more damage?`}</p>
    </blockquote>
    <p>{`Start with 1CJ ATK > Link Isha > Link CJ.`}<br parentName="p"></br>{`
`}{`DPS with Isha when possible, focus on not getting hit by lunge attack.`}<br parentName="p"></br>{`
`}{`When he spits boulder, switch to Garoo & it it back into him.`}<br parentName="p"></br>{`
`}{`Then switch CJ, and do 4ATK > Link Isha > Link CJ > 4ATK > Isha 3 Up ATK`}<br parentName="p"></br>{`
`}{`He should be 50%HP after 2 of these, this will trigger next phase. Play's the same as before, just boulder spit travels faster now.`}</p>
    <h2 {...{
      "id": "24-after-the-eruption"
    }}>{`24: After the Eruption`}</h2>
    <h3 {...{
      "id": "new-nevea-1"
    }}>{`New Nevea`}</h3>
    <p>{`Warp `}<strong parentName="p">{`Rune Quarter`}</strong>{`, warp `}<strong parentName="p">{`Second Street`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to `}<strong parentName="p">{`Hogan`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Target is 3 Lumber, 1 Durable Stone`}<br parentName="p"></br>{`
`}{`Money can be short, if so sell in Pawn Shop.`}</p>
      </blockquote>
      <h5 {...{
        "id": "trade"
      }}>{`Trade`}</h5>
      <ul>
        <li parentName="ul">{`[P4]`}{` 6 Stone < 12 Ore (9 Stone Total)`}</li>
        <li parentName="ul"><em parentName="li">{`If missing Stone`}</em>{` `}{`[P3]`}{` 2 Lumber < 1 Stone (Make sure you have 3 Lumber left)`}</li>
        <li parentName="ul">{`3 Heavy Stone < 9 Stone`}</li>
        <li parentName="ul">{`1 Durable Stone < 3 Heavy Stone `}</li>
      </ul>
    </Menu>
    <p>{`Exit to `}<strong parentName="p">{`Rune Quarter`}</strong>{`, TP `}<strong parentName="p">{`Outlander Lane`}</strong>{`. Talk to `}<strong parentName="p">{`Rajiv`}</strong>{` twice.`}</p>
    <h2 {...{
      "id": "25-a-hot-spring-delicacy"
    }}>{`25: A Hot Spring Delicacy`}</h2>
    <ol>
      <li parentName="ol">{`Warp `}<strong parentName="li">{`Plaza`}</strong>{`, talk to `}<strong parentName="li">{`Shiva`}</strong>{`.`}</li>
      <li parentName="ol">{`Warp `}<strong parentName="li">{`Pasurate`}</strong>{`, talk to `}<strong parentName="li">{`Urmila`}</strong>{`.`}</li>
      <li parentName="ol">{`Warp `}<strong parentName="li">{`Farmside Menhir`}</strong>{`, go to `}<strong parentName="li">{`Snowpeak - Blizzard's Point`}</strong>{`.`}</li>
    </ol>
    <h3 {...{
      "id": "snowpeak---blizzards-point-1"
    }}>{`Snowpeak - Blizzard's Point`}</h3>
    <p>{`Go left avoiding battles, getting 1st 4 `}<strong parentName="p">{`Thunderbird Eggs`}</strong>{`. Then go back right to sign, and exit Runebarrows.`}<br parentName="p"></br>{`
`}{`Do this 2 more times, except stop on 3 eggs instead of 4.`}</p>
    <h3 {...{
      "id": "new-nevea-2"
    }}>{`New Nevea`}</h3>
    <p>{`Warp `}<strong parentName="p">{`Pasturage`}</strong>{`, talk to `}<strong parentName="p">{`Urmila`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Warp `}<strong parentName="p">{`Rune Quarter`}</strong>{`, exit to `}<strong parentName="p">{`Outlander Street`}</strong>{`. Talk to `}<strong parentName="p">{`Rajiv`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "inn-1"
      }}>{`Inn`}</h5>
      <p>{`Empowering Waters LVL2`}</p>
    </Menu>
    <p>{`Warp `}<strong parentName="p">{`Plaza`}</strong>{`, talk to `}<strong parentName="p">{`Shiva`}</strong>{`.`}</p>
    <h2 {...{
      "id": "26-deeper-into-the-ruins"
    }}>{`26: Deeper Into the Ruins`}</h2>
    <p>{`Warp `}<strong parentName="p">{`Farmside Menhir`}</strong>{`, go to `}<strong parentName="p">{`Snowpeak - Blizzard's Point`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After cutscene go back to the sign, Warp `}<strong parentName="p">{`Cindered Gate`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go right till sign, warp `}<strong parentName="p">{`Lava Reservoir`}</strong>{`.`}</p>
    <h4 {...{
      "id": "puzzle-7"
    }}>{`Puzzle 7`}</h4>
    <PuzzleWithSolution puzzle={[[1, 1], [2, 3], [2, 1], [1, 0], [2, 2], [2, 0], [1, 1], [3, 3], [2, 1], [1, 0], [3, 2], [1, 1], [2, 2], [1, 1], [2, 1], [2, 3], [1, 1], [1, 1], [3, 1], [2, 3], [2, 2], [0, 0], [2, 0], [1, 1], [3, 0]]} moves={[[12, -1], [6, 1], [5, 2], [10, 1], [15, 2], [16, 1], [17, 1], [22, 2], [23, 1], [18, 1], [13, 1], [14, -1], [9, 1], [4, 1]]} mdxType="PuzzleWithSolution" />
    <h3 {...{
      "id": "runebarrows---depths"
    }}>{`Runebarrows - Depths`}</h3>
    <p>{`Ignore all chests here.`}</p>
    <ol>
      <li parentName="ol">{`Get really close to 1st Lightning Barrier, CJ 3A.`}</li>
      <li parentName="ol">{`Wait till Lightning Slimejelly is very close to you. Dash > Air Dash through, break 2nd Lightning Barrier`}</li>
      <li parentName="ol">{`Get close to next Lightning Barrier, CJ DJ A UA A to break.`}</li>
      <li parentName="ol">{`Dash forward, jump > AD > jump > UA to hit Barrier, link Garoo, link CJ. Should be on top part, continue from here.`}</li>
    </ol>
    <h4 {...{
      "id": "forced-battle---wizards"
    }}>{`Forced Battle - Wizards`}</h4>
    <p>{`Pretty standard, 2 groups of 2 Wizards. Break shield with Isha, DPS with Isha + CJ.`}<br parentName="p"></br>{`
`}{`2nd group kill left one 1st, so less movement.`}</p>
    <p>{`Next screen jump over Golems, might take damage but worth it.`}</p>
    <h4 {...{
      "id": "forced-battle-2"
    }}>{`Forced Battle 2`}</h4>
    <p>{`Flans: Stay away from them, hit with Isha. Link CJ > Isha when possible.`}<br parentName="p"></br>{`
`}{`Drakes: Standard`}<br parentName="p"></br>{`
`}{`Lizards: Focus left ones first, focus on not getting hit. Chain Isha > CJ into dash is pretty good.`}<br parentName="p"></br>{`
`}{`Wizards: Standard`}</p>
    <p>{`Go forward till cutscene.`}</p>
    <h2 {...{
      "id": "27-the-truth-in-the-tale"
    }}>{`27: The Truth in the Tale`}</h2>
    <p>{`Run out to Menhir.`}</p>
    <h3 {...{
      "id": "lava-ruins"
    }}>{`Lava Ruins`}</h3>
    <p>{`Go to sign, warp `}<strong parentName="p">{`Ancient Workshop`}</strong>{`. Go `}<strong parentName="p">{`left`}</strong>{` to cutscene.`}</p>
    <h2 {...{
      "id": "28-to-the-rescue"
    }}>{`28: To the Rescue!`}</h2>
    <p>{`Go right to sign, go back to `}<strong parentName="p">{`New Nevea`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-nevea-3"
    }}>{`New Nevea`}</h3>
    <p>{`TP `}<strong parentName="p">{`Outlander Lane`}</strong>{`, go to Inn.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Farmside Menhir`}</strong>{`. Go left 2 screens.`}</p>
    <h4 {...{
      "id": "golem"
    }}>{`Golem`}</h4>
    <p>{`Standard stuff.`}</p>
    <h2 {...{
      "id": "29-after-the-truth"
    }}>{`29: After the Truth`}</h2>
    <ol>
      <li parentName="ol">{`Walk to `}<strong parentName="li">{`Residential District`}</strong>{`. Go to your house.`}</li>
      <li parentName="ol">{`Warp `}<strong parentName="li">{`Plaza`}</strong>{`, talk to `}<strong parentName="li">{`Shiva`}</strong>{`.`}</li>
      <li parentName="ol">{`Warp `}<strong parentName="li">{`Second Street`}</strong>{` and exit to `}<strong parentName="li">{`Outlander Lane`}</strong>{`. Talk to `}<strong parentName="li">{`Tatara`}</strong>{`.`}</li>
      <li parentName="ol">{`Warp `}<strong parentName="li">{`Plaza`}</strong>{`, talk to `}<strong parentName="li">{`Shiva`}</strong>{`.`}</li>
      <li parentName="ol">{`Walk to `}<strong parentName="li">{`Outlander Lane`}</strong>{`, talk to `}<strong parentName="li">{`Sarita`}</strong>{`.`}</li>
      <li parentName="ol">{`Warp `}<strong parentName="li">{`Residential Interior District`}</strong>{`, talk to `}<strong parentName="li">{`Awamuri's Wife`}</strong>{`.`}</li>
      <li parentName="ol">{`Warp `}<strong parentName="li">{`Second Street`}</strong>{`, `}<em parentName="li">{`buy Potions if needed`}</em>{` then warp `}<strong parentName="li">{`Rune Quarter`}</strong>{`. Go left for cutscene.`}</li>
      <li parentName="ol">{`Warp `}<strong parentName="li">{`Great Forest`}</strong>{`, instantly exit.`}</li>
      <li parentName="ol">{`Talk to `}<strong parentName="li">{`Lugo`}</strong>{` twice.`}</li>
      <li parentName="ol">{`Warp `}<strong parentName="li">{`Second Street`}</strong>{`, talk to `}<strong parentName="li">{`Squash`}</strong>{`.`}</li>
      <li parentName="ol">{`Exit `}<strong parentName="li">{`Second Street`}</strong>{`, talk to `}<strong parentName="li">{`Tatara`}</strong>{`.`}</li>
      <li parentName="ol">{`Warp `}<strong parentName="li">{`Plaza`}</strong>{`, talk to `}<strong parentName="li">{`Shiva`}</strong>{`.`}</li>
    </ol>
    <blockquote>
      <p parentName="blockquote">{`Should be 30 Stamps now.`}</p>
    </blockquote>
    <p>{`Talk to `}<strong parentName="p">{`Shiva`}</strong>{` to enter final dungeon.`}</p>
    <h2 {...{
      "id": "30-where-this-all-began"
    }}>{`30: Where This All Began`}</h2>
    <h4 {...{
      "id": "hurstwine-27654hp"
    }}>{`Hurstwine 27654HP`}</h4>
    <p>{`Start with Isha, hit Bandits, walk back. 3 more hits, link to CJ and back.`}<br parentName="p"></br>{`
`}{`Switch between CJ and Isha. You want to get Hurstwine near the middle of the screen.`}<br parentName="p"></br>{`
`}{`If he's in a corner, just hit him with Isha and focus on dodging.`}<br parentName="p"></br>{`
`}{`Once he's in the middle, use `}<strong parentName="p">{`Power Balm LVL5`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Dash behind him constantly with CJ and DPS.`}</p>
    <blockquote>
      <p parentName="blockquote">{`The Power Balm LV5 is used in the middle because it can run out on Sorcerer. If you're confident in your fights, you can use it at the start.`}</p>
    </blockquote>
    <h4 {...{
      "id": "sorcerer-32336hp"
    }}>{`Sorcerer 32336HP`}</h4>
    <p>{`DPS & dodge, if he bring up earth shield break with Garoo.`}<br parentName="p"></br>{`
`}{`Fire attack is the dangerous one, best way to dodge is to go behind him.`}</p>
    <p>{`Optimal Attack pattern:`}<br parentName="p"></br>{`
`}{`Isha 3A > Link CJ > Link Isha > Link CJ > Isha 3A > CJ 2A UA DA 1A > Isha`}</p>
    <h4 {...{
      "id": "sorcerer-pt2-13434hp"
    }}>{`Sorcerer Pt.2 13434HP`}</h4>
    <p>{`Double jump on to platform, double jump, hit with this pattern.`}<br parentName="p"></br>{`
`}{`Isha 3A > Link CJ > Link Isha > Link CJ > Isha 3A > CJ 2A UA DA 1A > Isha`}</p>
    <p>{`When he starts charging up big explosion, get on the platform, switch to Isha. R2 to blink through the explosion, and do the above pattern.`}</p>
    <p>{`Repeat until victory.`}</p>
    <p>{`Split on black screen after achievement. GG`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      